/**
 * Announcement priority levels
 */
export enum AnnouncementPriority {
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

/**
 * Announcement categories
 */
export enum AnnouncementCategory {
  GENERAL = 'GENERAL',
  PEDAGOGICAL = 'PEDAGOGICAL',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  TECHNICAL = 'TECHNICAL',
  EVENT = 'EVENT',
}

/**
 * Announcement visibility levels
 */
export enum AnnouncementVisibility {
  GLOBAL = 'GLOBAL',
  BY_ESTABLISHMENT = 'BY_ESTABLISHMENT',
  BY_CLASS = 'BY_CLASS',
  BY_SUBJECT = 'BY_SUBJECT',
  CUSTOM = 'CUSTOM',
}

/**
 * Announcement status
 */
export enum AnnouncementStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}

/**
 * Targeting mode for the announcement creation form (UI / API mapping)
 */
export enum AnnouncementTargetType {
  ALL = 'ALL',
  ROLE = 'ROLE',
  CLASS = 'CLASS',
}

/**
 * Target role when {@link AnnouncementTargetType.ROLE} is selected
 */
export enum AnnouncementTargetRole {
  STUDENT = 'STUDENT',
  TEACHER = 'TEACHER',
  PARENT = 'PARENT',
}
